import * as types from 'model/actionTypes'
import { PartnerT } from 'shared/types/model'

export function receiveUser (user: PartnerT | null) {
  return {
    type: types.RECEIVE_USER,
    user
  }
}
